import * as CryptoJS from 'crypto-js';
import { PAYMENT_VALIDATION_KEY } from './AppConstants';

export const getEncryptedString = (message) => {
  const secretKey = CryptoJS.enc.Utf8.parse(PAYMENT_VALIDATION_KEY);
  var iv = CryptoJS.enc.Utf8.parse(PAYMENT_VALIDATION_KEY);
  const cipherParams = { 
    mode: CryptoJS.mode.CBC, 
    iv: iv, 
    padding: CryptoJS.pad.Pkcs7 
  };
  var encrypted = CryptoJS.AES.encrypt(message, secretKey, cipherParams);

  return encrypted.toString();
};